var cache = {}

export default function(o, tagSlug, done){

  var server = o.util.getUrl('frontend')

  if(cache[tagSlug]){
    requestAnimationFrame(function(){
      done(cache[tagSlug])
    })
  } else {
    $.ajax({
      url: `${server}?type=sequence&tagSlug=${tagSlug}`,
      type: "GET",
      cache: false,
      headers: { "cache-control": "no-cache" },
    })
    .done(function(data, textStatus, jqXHR) {
      cache[tagSlug] = data
      done(data)
    })
    .fail(function(jqXHR, textStatus, errorThrown) {
      console.error('error loading sequence data')
      done()
    })
  }

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/data/sequence/sequence.js